module.exports = __webpack_public_path__ + "static/media/tier-10.f6b272b1.jpg";